package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Span
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("di_kotlin_inject")
@Composable
fun KotlinInjectDiPage() {
    BlogLayout(
        PageProperties(
            "Kotlin Inject",
            ""
        ),
        BlogProperties("Dependency Injection", "Kotlin Inject")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Span(Modifier.display(DisplayStyle.Contents).toAttrs()) {
                SpanText(
                    text = "Powered by Kotlin’s robust features like KSP and lazy initialization, which simplify the process of providing dependencies",
                    modifier = Modifier.padding(topBottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                SpanText(
                    text = "With the use of Kotlin typealias, it allows injecting multiple instances of the same type and even supports lambda injection",
                    modifier = Modifier.padding(topBottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                SpanText(
                    text = "Kotlin-inject acts as a code generator, creating the necessary boilerplate for effective dependency injection based on the setup and annotations you provide. Similarly to Dagger and Hilt, this results in a significant amount of code generated during compile-time. Koin functions similarly to a service locator pattern, creating and providing the dependencies we want in runtime when they are needed. This translates to less boilerplate code generated during compile-time.",
                    modifier = Modifier.padding(topBottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                KotlinCode(
                    code = """
                    kotlininject = "0.7.2"

                    kotlininject-compiler = { module = "me.tatarka.inject:kotlin-inject-compiler-ksp", version.ref = "kotlininject" }
                    kotlininject-runtime = { module = "me.tatarka.inject:kotlin-inject-runtime", version.ref = "kotlininject" }
                    
                    commonMain.dependencies {
                        implementation(libs.kotlininject.runtime)
                    }

                    ksp {
                        arg("me.tatarka.inject.generateCompanionExtensions", "true")
                    }
                    
                    //ksp(libs.kotlinInject.compiler)

                    dependencies {
                        add("kspAndroid", libs.kotlininject.compiler)
                        add("kspIosX64", libs.kotlininject.compiler)
                        add("kspIosArm64", libs.kotlininject.compiler)
                        add("kspIosSimulatorArm64", libs.kotlininject.compiler)
                        add("kspJvm", libs.kotlininject.compiler)
                    }

                    """.trimIndent()
                )
            }
        }
    }
}